


























import { Component, Prop, Vue } from "vue-property-decorator";
import SvgIcon from "@/components/ui/SvgIcon.vue";

@Component({
  components: {
    SvgIcon,
  },
})
export default class MenuItem extends Vue {
  @Prop({
    required: true,
  })
  tooltip: string;

  @Prop({
    required: true,
  })
  itemName: string[];

  get isActive() {
    return this.itemName.includes(this.$route.name as string);
  }
}
